<template>
    <div class="third_diagram">
        <div class="two_diagram_box">
            <div class="two_diagram_box_main" id="main" ref="main">
                <div
                    id="canvas"
                    ref="canvas"
                    class="canvas-wrap"
                    :style="
                        `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                    "
                >
                    <img
                        class="bg-img"
                        src="../../../assets/image/diagram/diagram_021.svg"
                        alt
                        srcset
                    />
                    <div
                        v-for="(item, index) in datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                    >
                        <div class="data-box">
                            <div
                                class="data-box-name"
                                v-if="index == 0 || index == 24"
                            >
                                Ia(A)
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ item.ia }}</div>
                                <!-- <div class="box-data-unit">A</div> -->
                            </div>
                        </div>
                        <div class="data-box">
                            <div
                                class="data-box-name"
                                v-if="index == 0 || index == 24"
                            >
                                Ib(A)
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ item.ib }}</div>
                                <!-- <div class="box-data-unit">A</div> -->
                            </div>
                        </div>
                        <div class="data-box">
                            <div
                                class="data-box-name"
                                v-if="index == 0 || index == 24"
                            >
                                Ic(A)
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ item.ic }}</div>
                                <!-- <div class="box-data-unit">A</div> -->
                            </div>
                        </div>
                    </div>
                    <div class="data-wrap" style="top: 1%;left: 80%">
                        <div class="data-box">
                            <div class="data-box-name">
                                Ua
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ ua }}</div>
                            </div>
                        </div>
                        <div class="data-box">
                            <div class="data-box-name">
                                Ub
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ ub }}</div>
                            </div>
                        </div>
                        <div class="data-box">
                            <div class="data-box-name">
                                Uc
                            </div>
                            <div class="data-box-data">
                                <div class="box-data-data">{{ uc }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from "@/http/http-60.js";
export default {
    data() {
        return {
            left: "0",
            top: "-130",
            scale: 0.7,
            timer: null,
            datas: [
                {
                    point_id: "1572134063300272128",
                    name: "4011#1变进线柜(总电表1)",
                    top: 45,
                    left: 0,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572134289616527360",
                    name: "4012电房用电",
                    top: 45,
                    left: 5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572134460857376768",
                    name: "4021G#1变电容主柜",
                    top: 45,
                    left: 8.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572134583989559296",
                    name: "4031G#1变电容辅柜1",
                    top: 45,
                    left: 12.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572134713161539584",
                    name: "4041G#1变电容辅柜2",
                    top: 45,
                    left: 16.8,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572134937728770048",
                    name: "4051一通",
                    top: 45,
                    left: 21,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572134992246333440",
                    name: "4052#5高杆灯",
                    top: 45,
                    left: 25,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135053772578816",
                    name: "4053#6高杆灯",
                    top: 45,
                    left: 29,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135100601982976",
                    name: "4054#7高杆灯",
                    top: 45,
                    left: 33,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135174434316288",
                    name: "4055#8高杆灯",
                    top: 45,
                    left: 37.3,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135231699148800",
                    name: "4056  3A场轨道吊接电箱DX4",
                    top: 45,
                    left: 41.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135286002802688",
                    name: "4057   3A场轨道吊接电箱DX5",
                    top: 45,
                    left: 45.7,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135334757392384",
                    name: "4061#7门机",
                    top: 45,
                    left: 50,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135375123374080",
                    name: "4062直流屏电源1",
                    top: 45,
                    left: 54.3,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135458573246464",
                    name: "4063发电机房配电箱1AF",
                    top: 45,
                    left: 58.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135503443910656",
                    name: "4065  4B堆场内",
                    top: 45,
                    left: 62.7,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135551179284480",
                    name: "4064  3B场轨道吊接电箱DX1",
                    top: 45,
                    left: 66.8,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135596716843008",
                    name: "4071#5门机",
                    top: 45,
                    left: 70.8,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135650609455104",
                    name: "4135机修维修区、电焊棚、 物资室",
                    top: 45,
                    left: 74.8,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135725981097984",
                    name: "4073RMTG7",
                    top: 45,
                    left: 78.8,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572135765688573952",
                    name: "4081#3门机",
                    top: 45,
                    left: 82.9,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572136212243537920",
                    name: "4084顺仁威车队、修车场",
                    top: 45,
                    left: 87,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572136270015881216",
                    name: "4082#2充电桩",
                    top: 45,
                    left: 91,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572136351704145920",
                    name: "4083RMTG6",
                    top: 45,
                    left: 95,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572136760808169472",
                    name: "4181#2变进线市电",
                    top: 92,
                    left: -0.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                // {
                //     point_id: "1572138194182201344",
                //     name: "5000发电机进线",
                //     top: 92,
                //     left: 1.5,
                //     ia: "",
                //     ib: "",
                //     ic: ""
                // },
                {
                    point_id: "1572136844547448832",
                    name: "4171出线至#3专变P02柜",
                    top: 92,
                    left: 5.3,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572136896762339328",
                    name: "4161G#2变电容主柜",
                    top: 92,
                    left: 9,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572136944057311232",
                    name: "4151G#2变电容辅柜1",
                    top: 92,
                    left: 13,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137009698168832",
                    name: "4141G#2变电容辅柜1",
                    top: 92,
                    left: 17,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137246475018240",
                    name: "4131发电机充电",
                    top: 92,
                    left: 21,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137330528870400",
                    name: "4132#11高杆灯",
                    top: 92,
                    left: 25,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137393745420288",
                    name: "4074备用回路",
                    top: 92,
                    left: 29,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137448502059008",
                    name: "4133  3B场轨道吊接电箱编号DX2",
                    top: 92,
                    left: 33,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137499093753856",
                    name: "4134  3B场轨道吊接电箱编号DX3",
                    top: 92,
                    left: 37,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137543335272448",
                    name: "4136  4B堆场内",
                    top: 92,
                    left: 41,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137589678137344",
                    name: "4121#6门机",
                    top: 92,
                    left: 45,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137641624592384",
                    name: "4122  9号高杆灯旁",
                    top: 92,
                    left: 49,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137689322217472",
                    name: "4123#9高杆灯",
                    top: 92,
                    left: 53,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137753369239552",
                    name: "4124#10高杆灯",
                    top: 92,
                    left: 58,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137801121390592",
                    name: "4125#1充电桩",
                    top: 92,
                    left: 62,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137845669093376",
                    name: "4111#4门机",
                    top: 92,
                    left: 66,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137896143347712",
                    name: "4112门机接电箱AP6",
                    top: 92,
                    left: 70,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137938656813056",
                    name: "4113桥洞",
                    top: 92,
                    left: 74,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572137994814349312",
                    name: "4101#1门机",
                    top: 92,
                    left: 78,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572138043954814976",
                    name: "4104备用回路",
                    top: 92,
                    left: 82,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572138093233692672",
                    name: "4102RMTG5",
                    top: 92,
                    left: 86,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572138135940096000",
                    name: "4103RMTG4",
                    top: 92,
                    left: 90,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    point_id: "1572136417617633280",
                    name: "4000联络",
                    top: 92,
                    left: 96,
                    ia: "",
                    ib: "",
                    ic: ""
                }
            ],
            ua: "",
            ub: "",
            uc: ""
        };
    },
    mounted() {
        this.zoom();
        this.drag();
        this.getData();
        this.setTimer();
        this.setImgSize();
        window.onresize = () => {
            this.setImgSize();
        };
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getData();
            }, 1000 * 60);
        },
        getData() {
            let pointIds = [];
            this.datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.datas.forEach(item => {
                    let point = valueJson[item.point_id];
                    if (item.point_id == "1572134063300272128") {
                        this.ua = point && point.v_a;
                        this.ub = point && point.v_b;
                        this.uc = point && point.v_c;
                    }
                    item.ia = point && point.a_a;
                    item.ib = point && point.a_b;
                    item.ic = point && point.a_c;
                });
            });
        },
        setImgSize() {
            if (window.innerWidth >= 2560) {
                this.basisUnitH = 1.2;
                this.basisUnitV = 1.2;
            } else if (window.innerWidth < 2560 && window.innerWidth >= 1900) {
                this.basisUnitH = 1.0;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1920 && window.innerWidth >= 1660) {
                this.basisUnitH = 0.82;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1660 && window.innerWidth >= 1420) {
                this.basisUnitH = 0.7;
                this.basisUnitV = 0.7;
            } else if (window.innerWidth < 1420 && window.innerWidth >= 1320) {
                this.basisUnitH = 0.6;
                this.basisUnitV = 0.6;
            } else {
            }
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function(event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function(event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function(en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function(en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function() {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.third_diagram {
    width: 100%;
    height: 100%;
    color: #fff;
    padding: 0 2rem 0rem 2rem;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;
    .two_diagram_box {
        margin: 0 auto;
        text-align: center;
        align-self: center;
        width: 100%;
        height: 100%;
        position: relative;
        .two_diagram_box_main {
            top: 0%;
            left: 0%;
            width: 100%;
            padding: 2rem 2rem 0 2rem;
            box-sizing: border-box;
            height: 100%;
            position: relative;
            overflow: hidden;
            cursor: move;
            .canvas-wrap {
                width: 100%;
                // min-height: 100%;
                // height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                box-sizing: border-box;

                .bg-img {
                    width: 100%;
                    height: 100%;
                }

                .data-wrap {
                    position: absolute;
                    color: #fff;
                    font-size: 0.65rem;
                    .data-box {
                        display: flex;
                        height: 1.4rem;
                        line-height: 1.4rem;
                        margin-bottom: 0.2rem;
                        .data-box-name {
                            color: #dbf743;
                            //   width: 1.4rem;
                        }
                        .data-box-data {
                            width: 3.2rem;
                            text-align: right;
                            background: #111f45;
                            border-radius: 0.8rem;
                            display: inline-flex;
                            .box-data-data {
                                flex: 1;
                                text-align: center;
                            }
                            .box-data-unit {
                                width: auto;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
